import React, { useEffect, useRef } from "react";
import Spinner from "./Spinner";
export default function InfinityScroll({ loading, callback, }) {
    const elementRef = useRef(null);
    const props = useRef({ loading, callback });
    useEffect(() => {
        props.current = { loading, callback };
    }, [loading, callback]);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !props.current.loading) {
                    props.current.callback();
                }
            });
        }, { rootMargin: "0px 0px 0px -40px", threshold: 1.0 });
        observer.observe(elementRef.current);
        return () => observer.disconnect();
    }, []);
    return React.createElement("div", { ref: elementRef }, loading && React.createElement(Spinner, null));
}
